export const persianFormalWithEmoji = [
  {
    sentence:
      "با افتخار دوره {COURSE_TITLE} را در فرادرس گذرانده و گواهینامه خود را دریافت نمودم! 🎓🌟",
    tone: "formal",
    course_title: true,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence:
      "یکی از دوره‌های فرادرس را با موفقیت به پایان رسانده و گواهینامه خود را دریافت کردم! 🎉🏆",
    tone: "formal",
    course_title: false,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence:
      "به تازگی دوره {COURSE_TITLE} را در فرادرس با موفقیت پشت سر گذاشته و گواهینامه خود را کسب نمودم! 🎓✨",
    tone: "formal",
    course_title: true,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence:
      "یک دوره آموزشی از فرادرس را به اتمام رسانده و گواهینامه خود را دریافت نمودم! 🎉🌟",
    tone: "formal",
    course_title: false,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence:
      "دوره {COURSE_TITLE} را با موفقیت به پایان رساندم و گواهینامه خود را دریافت کردم! 🎓🌟",
    tone: "formal",
    course_title: true,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence:
      "یکی از دوره‌های ارزشمند فرادرس را گذرانده و گواهینامه‌ام را دریافت کردم! 🎉🏅",
    tone: "formal",
    course_title: false,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence:
      "با افتخار دوره {COURSE_TITLE} را با موفقیت گذراندم و گواهینامه‌ام را اخذ نمودم! 🎓✨",
    tone: "formal",
    course_title: true,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence:
      "یک دوره فوق‌العاده از فرادرس را پشت سر گذاشته و گواهینامه خود را کسب نمودم! 🎉🌟",
    tone: "formal",
    course_title: false,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence:
      "به تازگی دوره {COURSE_TITLE} را در فرادرس گذراندم و گواهینامه‌ام را دریافت کردم! 🎓🌟",
    tone: "formal",
    course_title: true,
    lang: "fa",
    using_emoji: true,
  },
  {
    sentence:
      "یکی از دوره‌های آموزشی فرادرس را با موفقیت به پایان رسانده و گواهینامه خود را کسب نمودم! 🎉✨",
    tone: "formal",
    course_title: false,
    lang: "fa",
    using_emoji: true,
  },
];
